import { createContext, useContext, type ReactNode } from 'react';
import { useAuth } from '@/shared/context/AuthContext';
import {
  useRealtimeConnection,
  type RealtimeConnectionStatus,
} from './useRealtimeConnection';

const RealtimeConnectionContext = createContext<RealtimeConnectionStatus>({
  connected: false,
  live: false,
});

/**
 * One WebSocket per authenticated org session; exposes connection + liveness.
 */
export function RealtimeConnectionProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated, token } = useAuth();
  const status = useRealtimeConnection({
    enabled: isAuthenticated && Boolean(token),
  });

  return (
    <RealtimeConnectionContext.Provider value={status}>
      {children}
    </RealtimeConnectionContext.Provider>
  );
}

export function useRealtimeConnectionState(): RealtimeConnectionStatus {
  return useContext(RealtimeConnectionContext);
}
